import { useUnmount } from 'react-use';
import { Mode } from '../../../../../../general-types';
import {
  challengeProfileStore,
  type ChallengeProfileForms,
} from '../../../../../stores/challengeProfileStore';

// use under obsorver
export const useChallengeFormMode = (form: ChallengeProfileForms) => {
  const { formsModeConfig, setFormMode } = challengeProfileStore;

  const mode = formsModeConfig[form];
  const setEdit = () => setFormMode(form, 'EDIT');
  const setView = () => setFormMode(form, 'VIEW');
  const setMode = (newMode: Mode) => setFormMode(form, newMode);

  useUnmount(() => {
    setFormMode(form, 'VIEW');
  });

  return {
    mode,
    setEdit,
    setView,
    setMode,
  };
};
